import React from 'react'
import { Route, Routes } from 'react-router-dom';
import RecruitmentLayout from '../Pages/RecruitmentLayout';
import MyDeals from '../../Deal/Pages/MyDeals';

const DealRoutes = () => {
  return (
    <Routes>
        <Route element={<RecruitmentLayout />}>
          <Route path="/my-deals" element={<MyDeals />} />
        </Route>
    </Routes>
  );
};

export default DealRoutes;
